import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_9 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.9 Case 9</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_9"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 9. This is a negative case.
                Beginning at the level of the cerebellum and moving superiorly,
                you may notice that this scan appears more smooth than the
                others. This is likely due to reconstruction and does not affect
                the interpretation of this scan.
              </p>
              <p>
                As we enter into the temporal and occipital regions, stopping at
                this level, activity appears more diffuse, and there may be loss
                of gray-white contrast. However, it is important to review all
                the slices within the temporal and occipital regions. Moving up
                just one slice, it is clear that, in fact, there is good
                gray-white contrast, and there is good delineation of white
                matter tracts on the left as well as on the right. Therefore,
                there is no loss of gray-white contrast in either the temporal
                or occipital lobes, and this pattern continues throughout the
                remainder of the temporal and occipital regions.
              </p>
              <p>
                As we move into the frontal lobes, seen here, distinct white
                matter tracts are easily identifiable on the left as well as on
                the right. These fingerlike projections produce the typical
                scalloping pattern that has been previously seen. In between
                these fingerlike projections of white matter, less intense
                activity is seen in the gray matter. Therefore, there is
                preserved gray-white contrast in the frontal cortices.
                Continuing to move superiorly, white matter tracts are
                delineated on either side, identified here as well as here, with
                preserved gray-white contrast throughout.
              </p>
              <p>
                As we enter into the upper parietal regions, white matter tracts
                are also seen on the right-hand side and left-hand side,
                coursing from the front of the brain to the back of the brain.
                In the medial parietal region, which houses the precuneus, no
                increased activity is seen in the gray matter of the midline
                parietal region. After reviewing the remainder of the slices, it
                is clear that there is normal gray-white contrast in the
                parietal region. Therefore, as there is no loss of gray- white
                contrast in any region, this case is negative. If you called
                this case positive, you may want to review the case once again
                in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-8"
          nextLesson="/module-4/module-4-1-10"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_2107068830&entry_id=1_ypaiyd0z&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_ypaiyd0z"
        />
      </main>
    </div>
  );
};

export default Module_4_1_9;
